export const DAYS_LEFT_KEY = "trial_banner.bold_text";

export const enum TRIAL_BANNER_TYPE {
    SHOPPER_ICP = "shopper_icp",
    SI_TRIAL = "si_trial",
    SI_AFTER_TRIAL = "si_after_trial",
    TRIAL = "trial",
    CC = "cc",
    REACTIVATION = "reactivation",
    TRIAL_ENDED = "trial_ended",
    AFTER_TRIAL = "after_trial",
}

export type Banner = TRIAL_BANNER_TYPE | null;

interface IBannerConfig {
    textKey?: string;
    ctaTextKey?: string;
}

export const TRIAL_BANNER_TEXT_SUFFIX_CONFIG: Partial<Record<TRIAL_BANNER_TYPE, string>> = {
    [TRIAL_BANNER_TYPE.SHOPPER_ICP]: "trial_banner.shopper_icp",
    [TRIAL_BANNER_TYPE.SI_TRIAL]: "trial_banner.v2.si_trial",
    [TRIAL_BANNER_TYPE.SI_AFTER_TRIAL]: "trial_banner.v2.si_after_trial",
    [TRIAL_BANNER_TYPE.TRIAL]: "trial_banner.v2.trial",
    [TRIAL_BANNER_TYPE.CC]: "trial_banner.v2.cc",
    [TRIAL_BANNER_TYPE.REACTIVATION]: "trial_banner.v2.reactivation",
    [TRIAL_BANNER_TYPE.TRIAL_ENDED]: "trial_banner.v2.trial_ended",
    [TRIAL_BANNER_TYPE.AFTER_TRIAL]: "trial_banner.v2.after_trial",
};

export const TRIAL_BANNER_CTA_TEXT_CONFIG: Partial<Record<TRIAL_BANNER_TYPE, string>> = {
    [TRIAL_BANNER_TYPE.SHOPPER_ICP]: "trial_banner.cta_text.shopper_icp",
    [TRIAL_BANNER_TYPE.SI_TRIAL]: "trial_banner.v2.cta_text.si_trial",
    [TRIAL_BANNER_TYPE.SI_AFTER_TRIAL]: "trial_banner.v2.cta_text.si_after_trial",
    [TRIAL_BANNER_TYPE.TRIAL]: "trial_banner.v2.cta_text.trial",
    [TRIAL_BANNER_TYPE.TRIAL_ENDED]: "trial_banner.v2.cta_text.trial_ended",
    [TRIAL_BANNER_TYPE.AFTER_TRIAL]: "trial_banner.v2.cta_text.after_trial",
};

export const BANNER_CONFIG: Record<TRIAL_BANNER_TYPE, IBannerConfig> = {
    [TRIAL_BANNER_TYPE.SHOPPER_ICP]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.SHOPPER_ICP],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.SHOPPER_ICP],
    },
    [TRIAL_BANNER_TYPE.SI_TRIAL]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.SI_TRIAL],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.SI_TRIAL],
    },
    [TRIAL_BANNER_TYPE.SI_AFTER_TRIAL]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.SI_AFTER_TRIAL],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.SI_AFTER_TRIAL],
    },
    [TRIAL_BANNER_TYPE.TRIAL]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.TRIAL],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.TRIAL],
    },
    [TRIAL_BANNER_TYPE.CC]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.CC],
    },
    [TRIAL_BANNER_TYPE.REACTIVATION]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.REACTIVATION],
    },
    [TRIAL_BANNER_TYPE.TRIAL_ENDED]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.TRIAL_ENDED],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.TRIAL_ENDED],
    },
    [TRIAL_BANNER_TYPE.AFTER_TRIAL]: {
        textKey: TRIAL_BANNER_TEXT_SUFFIX_CONFIG[TRIAL_BANNER_TYPE.AFTER_TRIAL],
        ctaTextKey: TRIAL_BANNER_CTA_TEXT_CONFIG[TRIAL_BANNER_TYPE.AFTER_TRIAL],
    },
};
